import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/$siteId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/settings/$siteId/general",
      params: { siteId: params.siteId },
    });
  },
});
